import { useState, useEffect, useCallback } from "react";

export function useJsPDF() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    if (window.jspdf) { setReady(true); return; }
    try {
      const { jsPDF } = await import('jspdf');
      window.jspdf = { jsPDF };
      setReady(true);
      setError(false);
    } catch (err) {
      console.error("Failed to load jsPDF:", err);
      setError(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const retry = useCallback(() => {
    setError(false);
    load();
  }, [load]);

  return { ready, error, retry };
}
